define('DateCalculations', [
  'underscore',
  'DateCalculations.Moments',
  'DateCalculations.Compare',
  'DateCalculations.BusinessDays',
  'DateCalculations.Test'
], function DateCalculations(
  _,
  DateCalculationsMoments,
  DateCalculationsCompare,
  DateCalculationsBusinessDays,
  DateCalculationsTest
) {
  'use strict';

  return _.extend(
    {},
    DateCalculationsMoments,
    DateCalculationsCompare,
    DateCalculationsBusinessDays,
    {
      mountToApp: function mountToApp() {
        DateCalculationsTest.runIfEnabled();
      }
    }
  );
});
